'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'meteor';
var width = 512;
var height = 512;
var aliases = [9732];
var unicode = 'f753';
var svgPathData = ['M0 309c0 112.1 90.9 203 203 203 72.4 0 139.4-38.6 175.7-101.3L496 208 436.1 212.6 512 0 299.4 75.9 304 16 101.3 133.4C38.6 169.7 0 236.6 0 309zm320 11a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z', 'M64 320a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMeteor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;